"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EMCMLoginServiceConfiguration", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginServiceConfiguration["default"];
  }
});
Object.defineProperty(exports, "EMCMLoginServiceConfigurationUAT", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginServiceConfigurationUAT["default"];
  }
});
Object.defineProperty(exports, "EMCMLoginServiceConfigurationPPE", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginServiceConfigurationPPE["default"];
  }
});
Object.defineProperty(exports, "EMCMLoginServiceConfigurationProd", {
  enumerable: true,
  get: function get() {
    return _EMCMLoginServiceConfigurationProd["default"];
  }
});
exports["default"] = void 0;

var _EMCMLoginService = _interopRequireDefault(require("./EMCMLoginService"));

var _EMCMLoginServiceConfiguration = _interopRequireDefault(require("./configurations/EMCMLoginServiceConfiguration"));

var _EMCMLoginServiceConfigurationUAT = _interopRequireDefault(require("./configurations/EMCMLoginServiceConfigurationUAT"));

var _EMCMLoginServiceConfigurationPPE = _interopRequireDefault(require("./configurations/EMCMLoginServiceConfigurationPPE"));

var _EMCMLoginServiceConfigurationProd = _interopRequireDefault(require("./configurations/EMCMLoginServiceConfigurationProd"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _EMCMLoginService["default"];
exports["default"] = _default;